import React from "react";

class StageOverlay extends React.Component {
  state = {};

  componentDidMount() {
    this._setListeners();
  }

  componentWillUnmount() {
    this._removeListeners();
  }

  _setListeners = () => {};

  _removeListeners = () => {};

  render() {
    const zoom = this.props.zoom ?? 1;
    const overlayStyle = {
      position: "absolute",
      top: 0,
      height: this.props.height,
      // when the content is shorter than the scroller viewport (single-canvas
      // page, zoomed out), height alone strands the crop shield's 100% above
      // the stage view's bottom; % here resolves against the scroller's
      // clientHeight, so this reaches exactly the visual bottom without
      // adding scroll extent
      minHeight: `calc(100% / ${zoom})`,
      // pre-divide so the visual width after scale() matches the parent,
      // like `width: 100%` resolved inside the old zoomed coordinate space
      width: `calc(100% / ${zoom})`,
      minWidth: this.props.layoutWidth,
      pointerEvents: "none",
      // transform instead of CSS zoom: rects measured inside are visual px
      // in every browser, old and new — no spec-vs-legacy zoom divergence
      transform: `scale(${zoom})`,
      transformOrigin: "0 0",
      // scale() creates a stacking context; sit above the crop-mode
      // viewport shield (z-index 1) so crop UI stays interactive
      zIndex: 2,
    };

    if (this.props.selected == null) {
      overlayStyle["pointerEvents"] = "none";
    }

    return (
      <div className="stage-view-overlay" style={overlayStyle} onMouseDown={this.props.onMouseDown}>
        {this.props.children}
      </div>
    );
  }
}

export default StageOverlay;
